import { useSyncExternalStore } from "react";

/**
 * The settings pages' page-wide "Show advanced" toggle (Plex's Show/Hide
 * Advanced button). Module store in the activeServer idiom: one boolean, a
 * listener set, persisted at rago.settings.advanced. Global on purpose —
 * the toggle spans every settings page.
 */
const KEY = "rago.settings.advanced";

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

let current = read();
const listeners = new Set<() => void>();

function setAdvanced(on: boolean): void {
  if (on === current) return;
  current = on;
  try {
    localStorage.setItem(KEY, on ? "1" : "0");
  } catch {
    // memory only
  }
  for (const fn of listeners) fn();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

const snapshot = (): boolean => current;

export function useAdvancedSettings(): [boolean, (on: boolean) => void] {
  const on = useSyncExternalStore(subscribe, snapshot, () => false);
  return [on, setAdvanced];
}
